import { getUserStatusKey } from './get-user-status-key';

export const getDataFromBlock = ({ block, widget, isUserLogged }) => {
  if (block.data[getUserStatusKey(isUserLogged, widget)]) {
    return block.data[getUserStatusKey(isUserLogged, widget)];
  }
  if (!block.data[widget.loggedKey] && !block.data[widget.notLoggedKey]) {
    return block.data;
  }
  return null;
};
